function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.2,1.37006a.99658.99658,0,0,0-1,1V6.64a.9965.9965,0,0,0,1,1H8.84V1.37006Zm17.6,0H15.16V7.64H20.8a.9965.9965,0,0,0,1-1V2.37006A1.00945,1.00945,0,0,0,20.8,1.37006Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.91,8.64v12.49a1.49793,1.49793,0,0,1-1.5,1.5H4.52a1.49793,1.49793,0,0,1-1.5-1.5V8.64H8.84v3.12012a1.00291,1.00291,0,0,0,1,1h4.32a1.00291,1.00291,0,0,0,1-1V8.64Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.16,1.37006v9.89a.5.5,0,0,1-.5.5H10.34a.5.5,0,0,1-.5-.5v-9.89Z"
});

var SvgProduct = function SvgProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product.ffab1220.svg";
export { ForwardRef as ReactComponent };